import { Component } from '@angular/core';

@Component({
  selector: 'app-signal-popin-send',
  templateUrl: './signal-popin-send.component.html',
  styleUrls: ['./signal-popin-send.component.scss'],
})
export class SignalPopinSendComponent {}
